import {
  Stack,
  Dropdown,
  SearchBox,
  getTheme,
  ISearchBoxStyles,
  IStackStyles,
  IDropdownStyles,
  HighContrastSelector
} from '@fluentui/react';
import React from 'react';
import { IDropdownOption } from '@fluentui/react';

export interface LookupSearchProps {
  className?: string;
  defaultKey: string;
  options: IDropdownOption[];
  onTenantChange: (key: string) => void;
  onSearch: (newValue) => void;
}

export const LookupSearch: React.FunctionComponent<LookupSearchProps> = props => {
  const { palette, fonts } = getTheme();

  const containerStyle: Partial<IStackStyles> = {
    root: {
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.08)',
      borderRadius: 4,
      border: 0,
      selectors: {
        [HighContrastSelector]: {
          border: '1px solid',
          borderColor: palette.white,
          borderRadius: 2
        }
      }
    }
  };

  const dropdownStyle: Partial<IDropdownStyles> = {
    root: { minWidth: 175, borderRight: '1px solid rgb(151, 151, 151)' },
    title: { border: 0 },
    dropdown: {
      border: 0
    }
  };

  const searchBoxStyle: Partial<ISearchBoxStyles> = {
    root: { border: 0 },
    icon: { color: palette.black }
  };

  const labelStyle: React.CSSProperties = {
    fontWeight: 'normal',
    fontSize: fonts.mediumPlus.fontSize,
    fontFamily: fonts.mediumPlus.fontFamily,
    lineHeight: fonts.mediumPlus.lineHeight
  };

  return (
    <Stack>
      {props.options.length > 1 && (
        <label style={labelStyle} htmlFor="tenantDropdown">
          Tenant List
        </label>
      )}
      <Stack horizontal styles={containerStyle} className={props.className}>
        {props.options.length > 1 && (
          <Stack.Item>
            <Dropdown
              id="tenantDropdown"
              aria-label="Tenant List"
              placeholder="Select tenant"
              defaultSelectedKey={props.defaultKey}
              options={props.options}
              onChange={(event, option): void => {
                option && typeof option.key === 'string' && props.onTenantChange(option.key);
              }}
              styles={dropdownStyle}
            />
          </Stack.Item>
        )}
        <Stack.Item grow>
          <SearchBox
            aria-label="Case searchbox"
            placeholder="Find cases by user, subject, or case ID"
            styles={searchBoxStyle}
            onSearch={(newValue: string): void => props.onSearch(newValue)}
          />
        </Stack.Item>
      </Stack>
    </Stack>
  );
};
